import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "back_to_top",
  "use": "back_to_top-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" xmlns=\"http://www.w3.org/2000/svg\" id=\"back_to_top\">\n\t<g fill=\"none\" fill-rule=\"evenodd\">\n\t\t<rect width=\"40\" height=\"40\" rx=\"4\" />\n\t\t<path fill=\"currentColor\" d=\"M18.744 17.943a1.777 1.777 0 0 1 2.405-.1l.107.1 5.815 5.814a1 1 0 0 1-1.327 1.492l-.087-.077-5.658-5.657-5.656 5.657a1 1 0 0 1-1.327.077l-.087-.077a1 1 0 0 1-.078-1.327l.078-.088 5.815-5.814ZM26 12a1 1 0 0 1 .117 1.993L26 14H14a1 1 0 0 1-.117-1.993L14 12h12Z\" />\n\t</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol